import { create } from 'zustand';

interface NavigatorConnectionLike {
	effectiveType?: 'slow-2g' | '2g' | '3g' | '4g';
	addEventListener: (type: 'change', listener: () => void) => void;
}

export interface NetworkInfoState {
	effectiveType: 'slow-2g' | '2g' | '3g' | '4g' | undefined;
	refresh: () => void;
}

let initialized = false;

function getConnection(): NavigatorConnectionLike | undefined {
	if (typeof window === 'undefined') return undefined;
	const maybeNavigator = navigator as Navigator & {
		connection?: NavigatorConnectionLike;
	};
	return maybeNavigator.connection;
}

const useNetworkInfoStore = create<NetworkInfoState>((set) => {
	const initialEffectiveType =
		typeof window !== 'undefined' ? getConnection()?.effectiveType : undefined;
	const refresh = async () => {
		if (typeof window === 'undefined') return;
		const connection = getConnection();
		set({ effectiveType: connection?.effectiveType });
	};

	if (!initialized && typeof window !== 'undefined') {
		initialized = true;
		const connection = getConnection();
		set({ effectiveType: connection?.effectiveType });
		const onChange = () =>
			set({ effectiveType: getConnection()?.effectiveType });
		if (connection) {
			try {
				connection?.addEventListener('change', onChange);
			} catch (e) {
				console.error('Error adding event listener to connection:', e);
			}
		}
	}

	return { effectiveType: initialEffectiveType, refresh };
});

export { useNetworkInfoStore };
